import React from "react"

const SingleInput = (props) => (  
  <div className="form-row" title={props.title}>
    <input
      className="form-input input__field"
      name={props.name}
      type={props.inputType}
      value={props.content}
      required={props.required}
      onChange={props.controlFunc}
      onFocus={props.focusFunc}
      onBlur={props.blurFunc}
      placeholder={props.placeholder} />
    <svg viewBox="0 0 20 20"><path fill="#D2D2D2" d={props.svg} /></svg>
  </div>
);

export default SingleInput;


// WEBPACK FOOTER //
// ./src/components/SingleInput.js